import $ from "cash-dom";
import { initModules } from './modules';
import '../scss/style.scss'


/**
 * DOMReady
 */
$(() => {
    initModules( $('body') );
});